import { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { ProtectedRoute } from './components/ProtectedRoute';
import { trackPageView } from './utils/analytics';

import { Home } from './pages/Home';
import { News, NewsDetail } from './pages/News';
import { Apps, AppDetail } from './pages/Apps';
import { Plans } from './pages/Plans';
import { About } from './pages/About';
import { LegalPage } from './pages/Legal';

import { AdminLogin } from './pages/admin/AdminLogin';
import { AdminDashboard } from './pages/admin/AdminDashboard';
import { AdminNews } from './pages/admin/AdminNews';
import { AdminApps } from './pages/admin/AdminApps';
import { AdminPlans } from './pages/admin/AdminPlans';
import { AdminLegal } from './pages/admin/AdminLegal';
import { AdminServices } from './pages/admin/AdminServices';
import { AdminPayments } from './pages/admin/AdminPayments';

import { UserLogin } from './pages/UserLogin';
import { UserDashboard } from './pages/UserDashboard';

function AnalyticsTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView(location.pathname, document.title);
  }, [location]);
  
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      {children}
      <Footer />
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AnalyticsTracker />
      <Toaster position="top-right" />
      <Routes>
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/noticias" element={<PublicLayout><News /></PublicLayout>} />
        <Route path="/noticias/:id" element={<PublicLayout><NewsDetail /></PublicLayout>} />
        <Route path="/apps" element={<PublicLayout><Apps /></PublicLayout>} />
        <Route path="/apps/:id" element={<PublicLayout><AppDetail /></PublicLayout>} />
        <Route path="/planes" element={<PublicLayout><Plans /></PublicLayout>} />
        <Route path="/nosotros" element={<PublicLayout><About /></PublicLayout>} />
        <Route path="/privacidad" element={<PublicLayout><LegalPage type="privacy" /></PublicLayout>} />
        <Route path="/terminos" element={<PublicLayout><LegalPage type="terms" /></PublicLayout>} />
        
        <Route path="/login" element={<UserLogin />} />
        <Route
          path="/panel"
          element={
            <ProtectedRoute redirectTo="/login">
              <UserDashboard />
            </ProtectedRoute>
          }
        />
        
        <Route path="/admin" element={<AdminLogin />} />
        <Route
          path="/admin/dashboard"
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/news"
          element={
            <ProtectedRoute>
              <AdminNews />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/apps"
          element={
            <ProtectedRoute>
              <AdminApps />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/plans"
          element={
            <ProtectedRoute>
              <AdminPlans />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/legal"
          element={
            <ProtectedRoute>
              <AdminLegal />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/services"
          element={
            <ProtectedRoute>
              <AdminServices />
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin/payments"
          element={
            <ProtectedRoute>
              <AdminPayments />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;